import * as React from 'react';
import { Switch, UIText2 } from '@cian/ui-kit';

import * as styles from './ServicesLayoutToggle.css';

export interface IServicesLayoutToggleProps {
  checked: boolean;
  disabled: boolean;
  showLabel: boolean;

  onChange(v: boolean): void;
}

export const ServicesLayoutToggle = ({ checked, disabled, showLabel, onChange }: IServicesLayoutToggleProps) => {
  const handleChange = (_: React.ChangeEvent<HTMLInputElement>, value: boolean) => onChange(value);

  return (
    <div className={styles['wrapper']}>
      {showLabel && (
        <div className={styles['label']}>
          <UIText2>{checked ? 'Включено' : 'Выключено'}</UIText2>
        </div>
      )}

      <Switch checked={checked} disabled={disabled} onChange={handleChange} data-testid="ServicesToggle" />
    </div>
  );
};
